(function () {'use strict';}());

angular.module('app').filter('tips', function() {
    return function(listing,question,score) {
    	if(!listing) return listing;
        var trace = angular.trace;
    	var results = [];

    	for(var i = 0, count = listing.length; i < count; i++)
    	{
            var item = listing[i];
            if(item.questionID === question.id && item.score === score) 
            {
                results.push(item);
                return results;
            }
    	}

    	return results;
    };
});